import PropTypes from "prop-types";
import { useState, useEffect } from "react";

const ProfileIncomeCircle = ({ income, imageUrl }) => {
  const [randomImage, setRandomImage] = useState(imageUrl);
  const [displayedIncome, setDisplayedIncome] = useState(0);

  useEffect(() => {
    setRandomImage(imageUrl);
  }, [imageUrl]);

  useEffect(() => {
    let start = 0;
    const duration = 1000; // 1 second
    const increment = (income / duration) * 10; // Calculate increment for smooth animation
    const interval = setInterval(() => {
      start += increment;
      if (start >= income) {
        clearInterval(interval);
        setDisplayedIncome(income); // Final value
      } else {
        setDisplayedIncome(Math.floor(start));
      }
    }, 10); // Update every 10 milliseconds

    return () => clearInterval(interval); // Cleanup the interval on component unmount
  }, [income]);

  return (
    <div className="flex flex-row items-center">
      <div className="flex flex-col items-center">
        <div className="profile-MainSection-circle-container flex items-center justify-center w-16 h-16 rounded-full border-2 border-gray-300 bg-slate-400 overflow-hidden">
          <img
            src={randomImage}
            alt="Profile"
            className="w-full h-full object-cover rounded-full"
          />
        </div>
        <p className="text-xl font-bold">{displayedIncome}</p>
      </div>
    </div>
  );
};

ProfileIncomeCircle.propTypes = {
  income: PropTypes.number.isRequired,
  imageUrl: PropTypes.string.isRequired,
};

export default ProfileIncomeCircle;
